import React, { useEffect, useRef, forwardRef } from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { mapScript } from "./mapScript";
import { themeOptions, isColorDark } from './utils';
import { _isEqual } from "../../../../shared/helpers/utils";
import { _axiosCall } from "../../../../shared/helpers/apicalls";


const apiUrl = process.env.API_ROOT + "/buyerslist/imageupload";

const ExportView = forwardRef((props, ref) => {
  const { content, headerContent, headerHTML, footerHTML, contentHTML, preview, searchTags, boundingBoxCoord, setIsMapLoaded, isMapLoaded, formValuesCheckboxes, reportLoaded, isEditMode, onSaveChanges, formValues , layoutStyle, fetchAi, AiResponse, setNestedModal, openDetailModal, user, onRequestPageDelete} = props;
  let rootElement;
  const customPhotosRef = useRef({});
  const customEditsRef = useRef({});

  let themes = user && user.mcTheme && themeOptions[user.mcTheme] ? themeOptions[user.mcTheme] : themeOptions.default;
  const A4_HEIGHT_PX = layoutStyle && layoutStyle.height? layoutStyle.height: 1588;
  const A4_WIDTH_PX= layoutStyle && layoutStyle.width? layoutStyle.width:"auto"
const HEADER_HEIGHT_PX = headerHTML?110:0;
const FOOTER_HEIGHT_PX = layoutStyle?0:60;
const PADDING_PX=layoutStyle?20:20;
const MARGIN_PX=layoutStyle?20:20
const themeFromStorage=localStorage.getItem("theme")
  useEffect(() => {
    const iframe = ref.current;
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    
    const themeType = formValues && formValues.theme ? formValues.theme : 'default';
    let theme = themes[themeType];
    console.log("backgroundColor updated",themeType, formValues.customColor, formValues.customBackgroundColor);
    
    if(themeType == "custom" && formValues.customColor){
      theme["primaryColor"] = formValues.customColor;
      theme["statUp"] = formValues.customColor;
      theme["statDown"] = formValues.customColor;
      theme["headerBackgroundColor"] = formValues.customColor;
    }
    if(themeType == "custom" && formValues.customBackgroundColor){
      theme["backgroundColor"] = formValues.customBackgroundColor;
      // theme["opacityPrimaryColor"]=formValues.customBackgroundColor
      theme["reportlayoutSwitchBackgroundColor"] = formValues.customBackgroundColor;
      const isDark = isColorDark(formValues.customBackgroundColor);
      console.log(isDark)
      if(isDark){
        theme["logoFilter"] = "brightness(0) invert(1)";
      }else{
        theme["logoFilter"] = "none";
      }
    }
    console.log(theme)
    if(themeType == "custom" && formValues.customTextColor){
      theme["headerTextColor"] = formValues.customTextColor;
      theme["headerSubtextColor"] = formValues.customTextColor;
      theme["sectionHeaderColor"] = formValues.customTextColor;
      theme["textColor"] = formValues.customTextColor;
      theme["reportlayoutTextColor"] = formValues.customTextColor;
      theme["textColor"] = formValues.customTextColor;
      theme["opacityElementColor"] = formValues.customTextColor;
    }

    const adjustIframeHeight = () => {
      setTimeout(() => {
        const scrollHeight = iframeDoc.body.scrollHeight;
        if (scrollHeight) {
          iframe.style.height = `${scrollHeight}px`;
          iframe.style.minHeight = `${scrollHeight}px`; // optional
        }
      }, 200); // small delay to ensure layout is settled
    };

   const createNewPage = (includeHeader = true) => {
    const pageDiv = document.createElement('div');
    pageDiv.classList.add('export-page');
  
    if (includeHeader) {
      const headerDiv = document.createElement('div');
      headerDiv.innerHTML = ReactDOMServer.renderToString(headerHTML);
      headerDiv.classList.add('export-page-header');
      pageDiv.appendChild(headerDiv);
    }
  
    // Optional: Footer logic can stay the same if needed
    // const footerDiv = document.createElement('div');
    // footerDiv.innerHTML = ReactDOMServer.renderToString(footerHTML);
    // footerDiv.classList.add('export-page-footer');
    // pageDiv.appendChild(footerDiv);
  
    rootElement.appendChild(pageDiv);
    return pageDiv;
  };

    const createMapPage = () => {
      const mapPage = createNewPage();
      const mapDiv = document.createElement('div');
      mapDiv.id = 'map';
      mapDiv.style.height = '1000px';
      mapPage.appendChild(mapDiv);

      const mapboxScript = iframeDoc.createElement('script');
      mapboxScript.src = 'https://api.mapbox.com/mapbox-gl-js/v2.10.0/mapbox-gl.js';
      mapboxScript.onload = () => {
        const mapInitScript = iframeDoc.createElement('script');
        mapInitScript.type = 'text/javascript';
        mapInitScript.text = mapScript(searchTags, boundingBoxCoord);
        iframeDoc.body.appendChild(mapInitScript);
      };
      iframeDoc.head.appendChild(mapboxScript);
    };

    const insertPageBreaks = () => {
      const contents = Array.from(iframeDoc.querySelectorAll('.page-section'));
      let accumulatedHeight = 0;
      let includeHeader = true;
      if (contents.length > 0 && contents[0].classList.contains('no-header')) {
        includeHeader = false;
      }
      let currentPageDiv = createNewPage(includeHeader);
    
      contents.forEach((content, index) => {
        const contentHeight = content.offsetHeight;
        accumulatedHeight += contentHeight;
    
        if (accumulatedHeight > (A4_HEIGHT_PX - HEADER_HEIGHT_PX - FOOTER_HEIGHT_PX) && index > 0) {
          accumulatedHeight = contentHeight;
          const hasNoHeader = content.classList.contains('no-header');
          currentPageDiv = createNewPage(!hasNoHeader);
        }
    
        currentPageDiv.appendChild(content);
      });
    
      formValuesCheckboxes.includes("showSnapshotMap") && createMapPage();
    };

    const replaceHeaders = () => {
      const headerSections = iframeDoc.querySelectorAll('.header-section');
      headerSections.forEach(headerSection => {
        headerSection.innerHTML = ReactDOMServer.renderToString(headerHTML);
      });
    };

    const replaceFooters = () => {
      const footerSections = iframeDoc.querySelectorAll('.footer-section');
      footerSections.forEach(footerSection => {
        footerSection.innerHTML = ReactDOMServer.renderToString(footerHTML);
      });
    };
    
    const attachOpenCompsHandlers = () => {
      // Attach .open-comps
      const openCompsEls = iframeDoc.querySelectorAll('.open-comps');
      openCompsEls.forEach(el => {
        el.removeEventListener('click', handleOpenCompsClick);
        el.addEventListener('click', handleOpenCompsClick);
      });
    
      // Attach .open-detail
      const openDetailEls = iframeDoc.querySelectorAll('.open-detail');
      openDetailEls.forEach(el => {
        el.removeEventListener('click', handleOpenDetailClick);
        el.addEventListener('click', handleOpenDetailClick);
      });
    };
    
    const getChangedTrackedContent = function () {
      var iframe = ref.current;
      var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    
      var changes = {};
      var elements = iframeDoc.querySelectorAll(".track-original");
    
      elements.forEach(function (el) {
        var id = el.id;
        var originalValue = el.getAttribute("data-original");
        var currentValue = el.matches("[data-rich='true']") ? el.innerHTML : el.innerText;
    
        if (id && originalValue !== currentValue) {
          el.setAttribute("data-changed", "true");
          changes[id] = { originalValue: originalValue, newValue: currentValue };
        } else {
          el.removeAttribute("data-changed");
        }
      });
    
      return changes;
    };


    
    const handleOpenCompsClick = (e) => {
      e.preventDefault();
      e.stopPropagation(); // 🔒 Prevents bubbling up
      const clickedKey = e.currentTarget.getAttribute("data-comp-key");
      const clickedCompType = e.currentTarget.getAttribute("data-comp-type");

      // Determine section (active vs sold) and position from DOM structure
      // so restored reports can map old comp IDs to fresh data
      let compSection = null;
      let compSectionIndex = -1;
      const container = e.currentTarget.closest('.property-comparison-container');
      if (container) {
        const allContainers = Array.from(iframeDoc.querySelectorAll('.property-comparison-container'));
        const containerIdx = allContainers.indexOf(container);
        compSection = containerIdx === 0 ? "active" : "sold";
        const sectionBtns = Array.from(container.querySelectorAll('.open-comps'));
        compSectionIndex = sectionBtns.indexOf(e.currentTarget);
      }

      saveEdits(); // Persist all current edits before opening comp selector
      const changes = getChangedTrackedContent();
      const data = { compKey: clickedKey, changes, compType: clickedCompType, compSection, compSectionIndex };

      setNestedModal(data);
      console.log("Clicked .open-comps", e.currentTarget);
    };
    
    const handleOpenDetailClick = (e) => {
      e.preventDefault();
      e.stopPropagation(); // 🔒 Prevents bubbling up
      const key = e.currentTarget.getAttribute("data-key");
      if (key) {
        openDetailModal(key);
        console.log("Clicked .open-detail with key:", key);
      } else {
        console.warn("Missing data-key on .open-detail element");
      }
    };
    
    
    const attachImageUploadHandlers = () => {
      const uploadEls = iframeDoc.querySelectorAll('.trigger-upload-image');
    
      uploadEls.forEach(el => {
        el.removeEventListener('click', handleImageUploadClick);
        el.addEventListener('click', handleImageUploadClick);
      });
    };
    
    const handleImageUploadClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
    
      const el = e.currentTarget;
      const key = el.getAttribute("data-image-key");
      if (!key) return;
    
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
    
      input.onchange = () => {
        const file = input.files[0];
        if (!file) return;
    
        const formData = new FormData();
        formData.append("file", file);
    
        const photoData = {
          url: apiUrl, // replace with your actual API endpoint
          method: "post",
          query: formData,
        };
    
        _axiosCall(photoData)
          .then((res) => {
            const imageUrl = res[0]; // or res[0].preview depending on your API response
    
            if (imageUrl) {
              const targetImg = iframeDoc.getElementById(key);
              if (targetImg && targetImg.tagName === 'IMG') {
                targetImg.src = imageUrl;
                customPhotosRef.current[key] = imageUrl;
                saveEdits();
              } else {
                console.warn(`No <img> found with id=${key}`);
              }
            }
          })
          .catch((error) => {
            console.error("Image upload failed", error);
          });
      };
    
      input.click();
    };

  
    const injectTheme = () => {
      const themeStyles = `
        :root {
          --primary-color: ${theme.primaryColor};
          --background-color: ${theme.backgroundColor};
          --header-background-color: ${theme.headerBackgroundColor};
          --header-text-color: ${theme.headerTextColor};
          --header-subtext-color: ${theme.headerSubtextColor};
          --section-header-color: ${theme.sectionHeaderColor};
          --section-subtext-color: ${theme.sectionSubtextColor};
          --table-border-color: ${theme.tableBorderColor};
          --footer-text-color: ${theme.footerTextColor};
          --stat-color: ${theme.statColor};
          --text-color: ${theme.textColor};
          --chart-color: ${theme.primaryColor};
          --stat-up: ${theme.statUp};
          --stat-down: ${theme.statDown};
          --logo-filter: ${theme.logoFilter ? theme.logoFilter : "none"};
          --report-layout-sub-heading-text:${theme.reportlayoutSubHeadingText};
          --opacity-background:${theme.opacityBackground};
          --opacity-element-color:${theme.opacityElementColor};
          --switch-background-color:${theme.switchBackgroundColor};
          --report-layout-background-color:${theme.reportLayoutBackgroundColor};
          --report-layout-primary-color:${theme.reportLayoutPrimaryColor};
          --report-layout-text-color:${theme.reportlayoutTextColor};
          --report-layout-switch-background-color:${theme.reportlayoutSwitchBackgroundColor};
          --report-layout-border-color:${theme.reportlayoutBorderColor};
          --postcard-image-background:${theme.postCardImageBackGround};
          --building-view-background-color:${theme.buildingViewBackGround};
          --building-view-text-color:${theme.buildingViewTextColor};
          --opacity-primary-color:${theme.opacityPrimaryColor};
          --cover-background-color:${theme.coverBackgroundColor};
          --cover-text-color:${theme.coverTextColor};

        }
      `;
      const styleEl = iframeDoc.createElement('style');
      styleEl.innerHTML = themeStyles;
      iframeDoc.head.appendChild(styleEl);
      console.log(themeStyles)
    };

    const applyCustomChanges = () => {
      // Re-apply uploaded photos
      var photos = customPhotosRef.current;
      Object.keys(photos).forEach(function (key) {
        var img = iframeDoc.getElementById(key);
        if (img && img.tagName === 'IMG') {
          img.src = photos[key];
        }
      });
      // When comps changed with "Update Suggested Price", discard all stale
      // text edits so freshly computed values are not overwritten.
      if (props.reportData && props.reportData.updateSuggestedPrice) {
        customEditsRef.current = {};
      }
      // Re-apply text edits that were persisted across re-renders
      var edits = customEditsRef.current;
      Object.keys(edits).forEach(function (id) {
        var target = iframeDoc.getElementById(id);
        if (!target) return;
        try {
          var parser = new DOMParser();
          var doc = parser.parseFromString(edits[id], 'text/html');
          var saved = doc.body.firstElementChild;
          if (saved && saved.getAttribute('data-changed') === 'true') {
            target.innerHTML = saved.innerHTML;
            target.setAttribute('data-changed', 'true');
            if (saved.hasAttribute('data-original')) {
              target.setAttribute('data-original', saved.getAttribute('data-original'));
            }
          }
        } catch (e) {
          // skip malformed entries
        }
      });
    };

    const renderContent = () => {
      console.log("renderContent")
      iframeDoc.open();
      iframeDoc.write(`
        <html>
          <head>
            <link href="https://api.mapbox.com/mapbox-gl-js/v2.10.0/mapbox-gl.css" rel="stylesheet" />
            ${headerContent}
            <style>
              body { margin: 0; overflow: hidden;  }
              #root { overflow: hidden;padding:${headerHTML || footerHTML ? '20px' : '0'};background:${headerHTML || footerHTML ? '#F5F7FA' : 'transparent'}; }
              .page-break {
                page-break-before: always;
              }
              .mapboxgl-map {
                min-width: 1080px;
                width: 100%;
              }
              .export-page {
                break-after: page;
                height: ${A4_HEIGHT_PX}${!isNaN(A4_HEIGHT_PX) ? "px" :""};
                width:${A4_WIDTH_PX}${!isNaN(A4_WIDTH_PX) ? "px" :""};
                position: relative;
                padding-bottom: ${FOOTER_HEIGHT_PX}${!isNaN(FOOTER_HEIGHT_PX) ? "px" :""};
                padding:0px;
                box-shadow:rgba(0, 0, 0, 0.12) 2px 2px 6px;
                margin-bottom:50px;
              }
              .report-container{
                padding:20px 40px;
              }
              .export-page:last-of-type{
                border-bottom:none;
              }
              .export-page-header {
                height: ${HEADER_HEIGHT_PX}px;
                margin-bottom: ${PADDING_PX}px;
              }
              .export-header{
                padding-left:30px;
                padding-right:30px;
              }
              .export-page-footer {
                height: ${FOOTER_HEIGHT_PX}px;
                margin-top: ${MARGIN_PX}px;
                position: absolute;
                bottom: 0;
                width: 100%;
                padding: 10px 25px;
              }
              @media print {
                .export-page {
                  border-bottom:none;
                  padding-bottom:0;
                  margin-bottom:0 !important;
                }
                .print-hide {
                  display:none !important;
                }
                #root{
                  padding:0;
                  background:transparent;
                }
                .delete-page-btn { display: none !important; }
              }
              .delete-page-btn {
                position: absolute;
                top: 10px;
                right: 10px;
                z-index: 10;
                width: 32px;
                height: 32px;
                border-radius: 50%;
                border: none;
                background: rgba(220, 53, 69, 0.92);
                color: #fff;
                cursor: pointer;
                display: none;
                align-items: center;
                justify-content: center;
                box-shadow: 0 1px 4px rgba(0,0,0,0.2);
                font-size: 16px;
                line-height: 1;
              }
              .delete-page-btn:hover { background: #b02a37; }
              body.edit-mode .delete-page-btn { display: flex; }
            </style>
          </head>
          <body id="${formValues.style ? formValues.style : "default"}" class="${themeType} ${user && user.role && Array.isArray(user.role) ? user.role.map(r => "role-"+r).join(" ") : ""}">
            <div id="root"></div>
          </body>
        </html>
      `);
      iframeDoc.close();
      rootElement = iframeDoc.getElementById('root');
      
      if (!rootElement) {
        console.error("Root element not found in the iframe.");
        return;
      }
      rootElement.innerHTML = "";
      if (contentHTML == null) {
        // Modal has been closed; skip render to avoid null.$$typeof crash.
        return;
      }
      const isReactComponent = typeof contentHTML === 'object' && contentHTML.$$typeof;
      console.log(isReactComponent);
      if (isReactComponent) {
        ReactDOM.render(contentHTML, rootElement, () => {
          insertPageBreaks();
          adjustIframeHeight();
          toggleEditMode(isEditMode); // Apply edit mode after rendering
          injectTheme();
          attachOpenCompsHandlers();
          attachImageUploadHandlers();
          applyCustomChanges();
          injectDeletePageButtons();
        });
      } else {
        ReactDOM.render(<div dangerouslySetInnerHTML={{ __html: contentHTML }} />, rootElement, () => {
          replaceHeaders();
          replaceFooters();
          adjustIframeHeight();
          toggleEditMode(isEditMode); // Apply edit mode after rendering
          injectTheme();
          attachOpenCompsHandlers();
          attachImageUploadHandlers();
          applyCustomChanges();
          injectDeletePageButtons();
        });
      }
    };

    const saveEdits = () => {
      getChangedTrackedContent();
      // Persist changed text edits so they survive re-renders (trackEdit reports)
      var changedEls = iframeDoc.querySelectorAll('[data-changed="true"][id]');
      changedEls.forEach(function (el) {
        customEditsRef.current[el.id] = el.outerHTML;
      });
      const editedContent = iframeDoc.getElementById('root').innerHTML;
      console.log(editedContent);
      onSaveChanges(editedContent); // Send the updated content to the parent component
    };

  const handleBlur = function (event) {
    var el = event.target;
    if (!el.classList.contains("editable")) return;
  
    if (el.classList.contains("track-original")) {
      var original = el.getAttribute("data-original");
      var current = el.matches("[data-rich='true']") ? el.innerHTML : el.innerText;
  
      if (original !== current) {
        el.setAttribute("data-changed", "true");
      } else {
        el.removeAttribute("data-changed");
      }
    }
  
    // Always save after change detection
    saveEdits();
  };


    const toggleEditMode = function (enableEditMode) {
      var iframe = ref.current;
      var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

      if (iframeDoc.body) {
        iframeDoc.body.classList.toggle("edit-mode", !!enableEditMode);
      }

      var nodes = iframeDoc.querySelectorAll(".editable");
      nodes.forEach(function (element) {
        if (enableEditMode) {
          element.setAttribute("contentEditable", "true");

          // Set baseline ONCE
          if (element.classList.contains("track-original") && !element.hasAttribute("data-original")) {
            // Use innerHTML if rich text, innerText otherwise
            var baseline = element.matches("[data-rich='true']") ? element.innerHTML : element.innerText;
            element.setAttribute("data-original", baseline);
          }

          element.addEventListener("blur", handleBlur);
        } else {
          element.removeAttribute("contentEditable");
          element.removeEventListener("blur", handleBlur);
        }
      });
    };

    const injectDeletePageButtons = function () {
      if (!onRequestPageDelete) return;
      var pages = iframeDoc.querySelectorAll(".export-page");
      pages.forEach(function (page, index) {
        if (page.querySelector(".delete-page-btn")) return;
        // Anchor absolute-positioned button without disturbing flow
        var computed = iframeDoc.defaultView.getComputedStyle(page);
        if (computed.position === "static") {
          page.style.position = "relative";
        }
        var btn = iframeDoc.createElement("button");
        btn.type = "button";
        btn.className = "delete-page-btn print-hide";
        btn.setAttribute("aria-label", "Delete page");
        btn.setAttribute("title", "Delete page");
        btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/></svg>';
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          var allPages = Array.from(iframeDoc.querySelectorAll(".export-page"));
          var currentIndex = allPages.indexOf(page);
          onRequestPageDelete(currentIndex);
        });
        page.appendChild(btn);
      });
    };

    
    renderContent();
    

   window.addEventListener('resize', adjustIframeHeight);

    return () => {
      window.removeEventListener('resize', adjustIframeHeight);
    };
  }, [contentHTML, headerHTML, footerHTML, searchTags, isMapLoaded, reportLoaded, isEditMode, preview]);

  return (
    <iframe ref={ref} scrolling="no" style={{ width: '100%', border: 'none', overflow: 'hidden', background: '#FFF', minHeight: `${A4_HEIGHT_PX == "auto" ? "100vh" : A4_HEIGHT_PX}${!isNaN(A4_HEIGHT_PX) ? "px" :""}` }} />
  );
});

const areEqual = (prevProps, nextProps) => {
  return prevProps.preview === nextProps.preview
  && prevProps.isEditMode === nextProps.isEditMode
  && prevProps.formValues.customColor === nextProps.formValues.customColor
  && prevProps.formValues.customBackgroundColor === nextProps.formValues.customBackgroundColor
  && prevProps.formValues.customTextColor === nextProps.formValues.customTextColor
  && prevProps.formValues.cover === nextProps.formValues.cover
  && prevProps.fetchAi===nextProps.fetchAi
  && prevProps.AiResponse===nextProps.AiResponse
  && prevProps.reportData===nextProps.reportData
};

export default React.memo(ExportView, areEqual);
